import { render, staticRenderFns } from "./customer_issues.vue?vue&type=template&id=04e70dd8&scoped=true&"
import script from "./customer_issues.vue?vue&type=script&lang=js&"
export * from "./customer_issues.vue?vue&type=script&lang=js&"
import style0 from "./customer_issues.vue?vue&type=style&index=0&id=04e70dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e70dd8",
  null
  
)

export default component.exports